<template>
  <div class="auction-access-banner">
    <AcvBanner
      id="issues-banner"
      variant="error"
      button-content="How to Resolve"
      class="tw-text-text-secondary"
      title="How To Resolve"
      @banner-button-click="handleBannerButtonClick"
    >
      <strong>{{ leadingMsg }}</strong>
      {{ issueMsg }}
    </AcvBanner>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { AcvBanner } from '@acv/shared-vuejs';
import useAuctionAccess from '@/composables/useAuctionAccess';

const { auctionAccessIssues, hasBlockingIssues } = useAuctionAccess();

const emit = defineEmits(['banner-button-click']);

const handleBannerButtonClick = () => {
  emit('banner-button-click');
};

const leadingMsg = computed(() => {
  if (hasBlockingIssues.value) {
    return 'Your access has changed due to your AuctionACCESS account:';
  }

  if (auctionAccessIssues.value.length === 1) {
    return 'There is an issue with your AuctionACCESS account. Please work with AuctionACCESS to resolve it to avoid impact to your ACV access:';
  }

  return 'There are issues with your AuctionACCESS account. Please work with AuctionACCESS to resolve them to avoid impact to your ACV access:';
});

const issueMsg = computed(() => {
  const defaultMsg = 'There is an issue with your AuctionACCESS Account';
  const first = auctionAccessIssues.value[0];
  const firstMsg = (first?.message ?? '').trim().replace(/\.$/, '');
  const hasFirstMsg = firstMsg.length > 0;

  if (!hasFirstMsg) return defaultMsg;

  if (auctionAccessIssues.value.length === 1) return `${firstMsg}.`;

  const extra = auctionAccessIssues.value.length - 1;
  const plural = extra > 1 ? 's' : '';
  return `${firstMsg}, and ${extra} other issue${plural}.`;
});
</script>

<style lang="scss" scoped>
#issues-banner {
  min-height: 100px;
}

:deep(.acv-banner) {
  justify-content: space-between;
}
</style>
